var scrVal = false;


var mutationObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    
    
    
    if(mutation.target.className.includes('bold_option_error'))
    {
      
      var x = document.getElementsByClassName(mutation.target.className)[0];
      
     
      
      
      if(scrVal == false)
      {
        x.scrollIntoView();
        console.log("scrolled");
        console.log(y);

        scrVal = true;
      }
      
      
    }
    
 
  });
});

mutationObserver.observe(document.documentElement, {
  attributes: true,
  subtree: true,
  childlist: true
});